export const messages = {
    videoTitle: 'Garage video',
    videoId: 'garage-card-video',
    ratingText: 'Trusted by 1000+ car owners',
};

export const garageCardHeadings = {
    main: 'Your car will be serviced here',
    other: 'Other service centres',
};

export const buttonLabels = {
    selectCentre: 'Select centre',
    checkOffers: 'Check offers',
};

export const rewardTags = {
    recommended: 'Recommended',
    pickAndDrop: 'FREE pickup and drop',
};
